import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { IMPACT_CARRY_CONCEPT_ID, IMPACT_STRATEGY_CONCEPT_ID } from '~/constants/concepts';
import { usePortfolioReviewContext } from '~/functions/review';
import { formatAsGermanDate } from '~/functions/helpers';
import { parseReviewVentureSnapshot, snapshotCarryEvidenceLinks, snapshotToCarryImpact, snapshotToStrategyImpact } from '~/functions/review-snapshot';
import { useGetImpactGoalQuery, useGetReviewRequestQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: '_ventureId',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var route = useRoute();
    var requestId = computed(function () {
      return route.params.requestId;
    });
    var ventureId = computed(function () {
      return route.params.ventureId;
    });
    var _usePortfolioReviewCo = usePortfolioReviewContext(),
      hasReviewerRole = _usePortfolioReviewCo.hasReviewerRole;
    var eventsTableRef = ref(null);
    var compareToSnapshot = ref(false);
    var _useGetReviewRequestQ = useGetReviewRequestQuery(computed(function () {
        return {
          id: requestId.value
        };
      }), computed(function () {
        return {
          enabled: hasReviewerRole.value && !!requestId.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useGetReviewRequestQ.result,
      refetchReviewRequest = _useGetReviewRequestQ.refetch;
    var refreshReviewData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _eventsTableRef$value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([refetchReviewRequest(), (_eventsTableRef$value = eventsTableRef.value) === null || _eventsTableRef$value === void 0 ? void 0 : _eventsTableRef$value.refetch()]);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function refreshReviewData() {
        return _ref2.apply(this, arguments);
      };
    }();
    onActivated(function () {
      if (hasReviewerRole.value && requestId.value) {
        refreshReviewData();
      }
    });
    var request = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getReviewRequest;
    });
    var requestTitle = computed(function () {
      var _request$value;
      return (_request$value = request.value) === null || _request$value === void 0 ? void 0 : _request$value.title;
    });
    var ventureRow = computed(function () {
      var _request$value2, _request$value2$ventu;
      return (_request$value2 = request.value) === null || _request$value2 === void 0 ? void 0 : (_request$value2$ventu = _request$value2.ventures) === null || _request$value2$ventu === void 0 ? void 0 : _request$value2$ventu.find(function (v) {
        return v.ventureId === ventureId.value;
      });
    });
    var reviewSnapshot = computed(function () {
      var _ventureRow$value, _ventureRow$value$lat;
      return parseReviewVentureSnapshot((_ventureRow$value = ventureRow.value) === null || _ventureRow$value === void 0 ? void 0 : (_ventureRow$value$lat = _ventureRow$value.latestEvent) === null || _ventureRow$value$lat === void 0 ? void 0 : _ventureRow$value$lat.snapshot);
    });
    var ventureStatus = computed(function () {
      var _ventureRow$value2;
      return ((_ventureRow$value2 = ventureRow.value) === null || _ventureRow$value2 === void 0 ? void 0 : _ventureRow$value2.status) || 'AWAITING_REVIEW';
    });
    var isApproved = computed(function () {
      return ventureStatus.value === 'APPROVED';
    });
    var isEditsRequested = computed(function () {
      return ventureStatus.value === 'EDITS_REQUESTED';
    });
    var hasReviewSnapshot = computed(function () {
      return reviewSnapshot.value !== null;
    });
    var useSnapshotView = computed(function () {
      return isApproved.value && hasReviewSnapshot.value;
    });
    var compareDiffEnabled = computed(function () {
      return compareToSnapshot.value && hasReviewSnapshot.value;
    });
    var snapshotCapturedAtLabel = computed(function () {
      var _reviewSnapshot$value, _reviewSnapshot$value2, _ventureRow$value3, _ventureRow$value3$la;
      var raw = (_reviewSnapshot$value = (_reviewSnapshot$value2 = reviewSnapshot.value) === null || _reviewSnapshot$value2 === void 0 ? void 0 : _reviewSnapshot$value2.capturedAt) !== null && _reviewSnapshot$value !== void 0 ? _reviewSnapshot$value : (_ventureRow$value3 = ventureRow.value) === null || _ventureRow$value3 === void 0 ? void 0 : (_ventureRow$value3$la = _ventureRow$value3.latestEvent) === null || _ventureRow$value3$la === void 0 ? void 0 : _ventureRow$value3$la.createdAt;
      if (!raw) return null;
      return formatAsGermanDate(String(raw)) || null;
    });
    var impactGoalQueryEnabled = computed(function () {
      return hasReviewerRole.value && !!ventureId.value && !!ventureRow.value && (!useSnapshotView.value || compareToSnapshot.value);
    });
    var _useGetImpactGoalQuer = useGetImpactGoalQuery(computed(function () {
        return {
          ventureId: ventureId.value
        };
      }), computed(function () {
        return {
          enabled: impactGoalQueryEnabled.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      impactGoalResult = _useGetImpactGoalQuer.result,
      impactGoalQueryLoading = _useGetImpactGoalQuer.loading;
    var impactGoal = computed(function () {
      var _impactGoalResult$val;
      return (_impactGoalResult$val = impactGoalResult.value) === null || _impactGoalResult$val === void 0 ? void 0 : _impactGoalResult$val.getImpactGoal;
    });
    var compareDataLoading = computed(function () {
      return compareDiffEnabled.value && impactGoalQueryLoading.value && !impactGoal.value;
    });
    var snapshotTocImpact = computed(function () {
      var _reviewSnapshot$value3;
      return (_reviewSnapshot$value3 = reviewSnapshot.value) !== null && _reviewSnapshot$value3 !== void 0 && _reviewSnapshot$value3.strategy ? snapshotToStrategyImpact(reviewSnapshot.value.strategy) : undefined;
    });
    var snapshotCarryImpacts = computed(function () {
      var _reviewSnapshot$value4;
      return (_reviewSnapshot$value4 = reviewSnapshot.value) !== null && _reviewSnapshot$value4 !== void 0 && _reviewSnapshot$value4.carry ? [snapshotToCarryImpact(reviewSnapshot.value.carry)] : [];
    });
    var snapshotCarryImpact = computed(function () {
      return snapshotCarryImpacts.value[0];
    });
    var liveTocImpact = computed(function () {
      var _impactGoal$value, _impactGoal$value$imp;
      return (_impactGoal$value = impactGoal.value) === null || _impactGoal$value === void 0 ? void 0 : (_impactGoal$value$imp = _impactGoal$value.impacts) === null || _impactGoal$value$imp === void 0 ? void 0 : _impactGoal$value$imp.find(function (impact) {
        return impact.conceptId === IMPACT_STRATEGY_CONCEPT_ID;
      });
    });
    var liveCarryImpacts = computed(function () {
      var _impactGoal$value$imp2, _impactGoal$value2;
      return ((_impactGoal$value$imp2 = (_impactGoal$value2 = impactGoal.value) === null || _impactGoal$value2 === void 0 ? void 0 : _impactGoal$value2.impacts) !== null && _impactGoal$value$imp2 !== void 0 ? _impactGoal$value$imp2 : []).filter(function (impact) {
        return Number(impact.conceptId) === IMPACT_CARRY_CONCEPT_ID;
      });
    });
    var liveCarryImpact = computed(function () {
      return liveCarryImpacts.value[0];
    });
    var displayTocImpact = computed(function () {
      if (useSnapshotView.value && snapshotTocImpact.value) {
        return snapshotTocImpact.value;
      }
      return liveTocImpact.value;
    });
    var compareTocImpact = computed(function () {
      if (!compareDiffEnabled.value) return undefined;
      if (useSnapshotView.value) return liveTocImpact.value;
      if (isEditsRequested.value) return snapshotTocImpact.value;
      return undefined;
    });
    var displayCarryImpacts = computed(function () {
      if (useSnapshotView.value && snapshotCarryImpacts.value.length) {
        return snapshotCarryImpacts.value;
      }
      return liveCarryImpacts.value;
    });
    var compareCarryImpact = computed(function () {
      if (!compareDiffEnabled.value) return undefined;
      if (useSnapshotView.value) return liveCarryImpact.value;
      if (isEditsRequested.value) return snapshotCarryImpact.value;
      return undefined;
    });
    var carryEvidenceLinksForImpact = function carryEvidenceLinksForImpact(impactId) {
      var _reviewSnapshot$value5;
      if (!useSnapshotView.value || !((_reviewSnapshot$value5 = reviewSnapshot.value) !== null && _reviewSnapshot$value5 !== void 0 && _reviewSnapshot$value5.carry)) return undefined;
      if (impactId !== reviewSnapshot.value.carry.impactId) return undefined;
      return snapshotCarryEvidenceLinks(reviewSnapshot.value.carry);
    };
    var showImpactCards = computed(function () {
      return !!displayTocImpact.value || displayCarryImpacts.value.length > 0;
    });
    var impactCardsLoading = computed(function () {
      if (useSnapshotView.value && !compareToSnapshot.value) return false;
      if (compareDataLoading.value) return true;
      return impactGoalQueryLoading.value && !impactGoal.value;
    });
    return {
      __sfc: true,
      proxy: proxy,
      route: route,
      requestId: requestId,
      ventureId: ventureId,
      hasReviewerRole: hasReviewerRole,
      eventsTableRef: eventsTableRef,
      compareToSnapshot: compareToSnapshot,
      result: result,
      refetchReviewRequest: refetchReviewRequest,
      refreshReviewData: refreshReviewData,
      request: request,
      requestTitle: requestTitle,
      ventureRow: ventureRow,
      reviewSnapshot: reviewSnapshot,
      ventureStatus: ventureStatus,
      isApproved: isApproved,
      isEditsRequested: isEditsRequested,
      hasReviewSnapshot: hasReviewSnapshot,
      useSnapshotView: useSnapshotView,
      compareDiffEnabled: compareDiffEnabled,
      snapshotCapturedAtLabel: snapshotCapturedAtLabel,
      impactGoalQueryEnabled: impactGoalQueryEnabled,
      impactGoalResult: impactGoalResult,
      impactGoalQueryLoading: impactGoalQueryLoading,
      impactGoal: impactGoal,
      compareDataLoading: compareDataLoading,
      snapshotTocImpact: snapshotTocImpact,
      snapshotCarryImpacts: snapshotCarryImpacts,
      snapshotCarryImpact: snapshotCarryImpact,
      liveTocImpact: liveTocImpact,
      liveCarryImpacts: liveCarryImpacts,
      liveCarryImpact: liveCarryImpact,
      displayTocImpact: displayTocImpact,
      compareTocImpact: compareTocImpact,
      displayCarryImpacts: displayCarryImpacts,
      compareCarryImpact: compareCarryImpact,
      carryEvidenceLinksForImpact: carryEvidenceLinksForImpact,
      showImpactCards: showImpactCards,
      impactCardsLoading: impactCardsLoading
    };
  }
});